module.exports = __webpack_public_path__ + "img/tian.1041c803.png";